import { themeOptionFactory as mobile } from "./mobile"
import { themeOptionFactory as kioskH } from "./kiosk-h"

export const themeOptionFactories = {
  mobile,
  "kiosk-h": kioskH,
}
